// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1tY6i","content":"LayoutSettings_content__1Jyw_"};